import React from "react";
import { Maximize, Maximize2 } from "lucide-react";
import { Button } from "@components/ui/button";
import { useFullscreenContext } from "./withFullscreen";

interface FullscreenToggleButtonProps {
  isExpanded: boolean;
}

export const FullscreenToggleButton: React.FC<FullscreenToggleButtonProps> = ({
  isExpanded,
}) => {
  const { isFullscreen, toggleFullscreen } = useFullscreenContext();

  if (!isExpanded) return null;

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleFullscreen}
      className="h-8 w-8 p-0 bg-muted hover:bg-lightGray rounded shrink-0"
      title={
        isFullscreen
          ? "Exit fullscreen ( Esc or Ctrl + Shift + F )"
          : "Fullscreen ( Ctrl + Shift + F )"
      }
    >
      {isFullscreen ? (
        <Maximize2 size={16} className="text-primary" />
      ) : (
        <Maximize size={16} className="text-primary" />
      )}
    </Button>
  );
};

export default FullscreenToggleButton;
